import { colors } from '@cimpress/react-components';
import styled from 'styled-components';

export const StyledText = styled.div`
  overflow-wrap: break-word;
  color: ${props => (props.errorText ? colors.danger.base : 'black')};
  font-weight: ${props => (props.boldText ? 'bold' : 'normal')};
`;
